import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import HistorySection from 'Components/HistorySection';
import type { IHistoryContext } from 'Containers/FormContextHandler';
import { withHistoryContext } from 'Containers/FormContextHandler';
import type { RelevantDocumentType } from '../definitions';
import { TreatmentHistorySection } from './components';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<RelevantDocumentType>[] = [];
const SurgicalTreatment = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  view,
}: IHistoryContext<IDocumentWithTypeV2<RelevantDocumentType>>): React.JSX.Element => (
  <HistorySection
    headerText={<FormattedMessage id="treatment.surgicalTreatment.title" />}
    newButton={
      startEdit ? (
        <DocumentCreationButton
          name="surgicalTreatment"
          text="treatment.surgicalTreatment.newSurgicalTreatment"
          onClick={startEdit({}, 'sleepApneaSurgicalTreatment')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      ) : (
        <></>
      )
    }
  >
    <TreatmentHistorySection
      documents={documents}
      startEdit={startEdit}
      type="sleepApneaSurgicalTreatment"
      view={view}
    />
  </HistorySection>
);

export default withHistoryContext(SurgicalTreatment);
